export const getAPI = () =>
  new Promise(function(resolve, reject) {
    fetch(`https://api.v1rage.com/wp-json/wp/v2`)
      .then(function(response) {
        return response.json();
      })
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(false);
      });
  });

export const getPageBySlug = slugName =>
  new Promise(function(resolve, reject) {
    fetch(`https://api.v1rage.com/wp-json/wp/v2/pages?slug=${slugName}`)
      .then(function(response) {
        return response.json();
      })
      .then(response => {
        resolve(response[0]);
      })
      .catch(err => {
        reject(false);
      });
  });

export const getAllCars = async (categoriesNumber, carType) =>
  new Promise(function(resolve, reject) {
    let params = "?";
    if (categoriesNumber) {
      params += `categories=${categoriesNumber}&`;
    }
    if (carType) {
      params += `typpojazdu=${carType}&`;
    }

    fetch(`https://api.v1rage.com/wp-json/wp/v2/cars${params}`)
      .then(function(response) {
        return response.json();
      })
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(false);
      });
  });

export const getSingleCar = carId =>
  new Promise(function(resolve, reject) {
    fetch(`https://api.v1rage.com/wp-json/wp/v2/cars/?slug=${carId}`)
      .then(function(response) {
        return response.json();
      })
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(false);
      });
  });

export const getSinglePage = pageName => {
  return new Promise(function(resolve, reject) {
    fetch(`https://api.v1rage.com/wp-json/wp/v2/pages/?slug=${pageName}`)
      .then(function(response) {
        return response.json();
      })
      .then(response => {
        if (response.length > 0) {
          resolve(response[0]);
        } else {
          reject(false);
        }
      })
      .catch(err => {
        reject(false);
      });
  });
};

export const offerPageGetUpperText = () =>
  new Promise(function(resolve, reject) {
    fetch(`https://api.v1rage.com/wp-json/wp/v2/pages/?search=oferta`)
      .then(function(response) {
        return response.json();
      })
      .then(response => {
        if (response.length > 0) {
          resolve(response[0]);
        } else {
          reject(false);
        }
      })
      .catch(err => {
        reject(false);
      });
  });
